<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
    tr.border_top td {
        border-top:1pt solid black;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Laporan Laba Rugi</h1>
            </div>
            <div class="section-body">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>Laba Rugi</h4>
                                <div class="card-header-form">
                                    <div class="input-group">
                                        <label class="mr-1 font-weight-bold">Tanggal Mulai</label>
                                        <vc-date-picker v-model="tanggal_mulai" :input-props='{class: "form-control",placeholder: "Tanggal Mulai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-3">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <label class="mr-1 font-weight-bold">Tanggal Selesai</label>
                                        <vc-date-picker v-model="tanggal_selesai" :input-props='{class: "form-control",placeholder: "Tanggal Selesai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-4">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <button @click="setFilter()" class="btn btn-outline-primary mr-3">Filter</button>
                                        <button @click="printPage()" class="btn btn-outline-success"> <i class="fas fa-file"></i> Print Laba Rugi</button>
                                        <!-- <a :href="siteUrl+'Laporan/exportExcel/pembelian?tanggal_mulai='+formatDate(tanggal_mulai)+'&tanggal_selesai='+formatDate(tanggal_selesai)+'&tipe='+url[1]" target="_blank" style="padding:7px 0px 0px 0px" class="btn btn-outline-info"><i class="fa fa-file-excel-o"></i> Export to Excel</a> -->
                                    </div>
                                </div>
                            </div>
                            <div id="printMe">
                                <div class="card-body p-0">
                                    <div class="table-responsive">
                                        <table class="table table-md">
                                            <thead>
                                                <tr style="background-color:#dc95dc;">
                                                    <th>#</th>
                                                    <th style="width:20%;">Tanggal</th>
                                                    <th></th>
                                                    <th style="text-align:right;padding-right:50px;">{{ tanggal_mulai | moment("DD MMMM YYYY") }} - {{ tanggal_selesai | moment("DD MMMM YYYY") }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Pendapatan dari Penjualan</th>
                                                </tr>
                                                <tr v-for="list in labaRugiList['pendapatan']" v-bind:key="list.id_coa" >
                                                    <td></td>
                                                    <td> &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo_flow) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <td></td>
                                                    <td colspan="2"> &nbsp; Total Pendapatan dan Penjualan</td>
                                                    <td style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(total_saldo('pendapatan')) }}</td>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Harga Pokok Penjualan</th>
                                                </tr>
                                                <tr v-for="list in labaRugiList['harga_pokok_penjualan']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td> &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo_flow) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <td></td>
                                                    <td colspan="2"> &nbsp; Total Harga Pokok Penjualan</td>
                                                    <td style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(total_saldo('harga_pokok_penjualan')) }}</td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2">Laba Kotor</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(laba_kotor) }}</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="4"></th>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Biaya Operasional</th>
                                                </tr>
                                                <tr v-for="list in labaRugiList['beban']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td>  &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo_flow) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <td></td>
                                                    <td colspan="2">  &nbsp;Total Harga Pokok Penjualan</td>
                                                    <td style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(total_saldo('beban')) }}</td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2">Pendapatan Bersih Operasional</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(pendapatan_bersih_operasional) }}</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="4"></th>
                                                </tr>
                                                <tr style="background-color: rgba(0,0,0,.04);">
                                                    <th></th>
                                                    <th colspan="3">Pendapatan Lainnya</th>
                                                </tr>
                                                <tr v-for="list in labaRugiList['pendapatan_lainnya']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td>  &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo_flow) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <td></td>
                                                    <td colspan="2"> &nbsp; Total Harga Pokok Penjualan</td>
                                                    <td style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(total_saldo('pendapatan_lainnya')) }}</td>
                                                </tr>
                                                <tr>
                                                    <th></th>
                                                    <th>Biaya Lainnya</th>
                                                </tr>
                                                <tr v-for="list in labaRugiList['biaya_lainnya']" v-bind:key="list.id_coa">
                                                    <td></td>
                                                    <td> &nbsp; {{ list.kode_akun }} </td>
                                                    <td> {{ list.nama_akun }} </td>
                                                    <td style="text-align:right;padding-right:50px;"> {{ 'Rp. '+ currencyFormat(list.total_saldo_flow) }}  </td>
                                                </tr>
                                                <tr class="border_top">
                                                    <td></td>
                                                    <td colspan="2"> &nbsp; Total Harga Pokok Penjualan</td>
                                                    <td style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(total_saldo('biaya_lainnya')) }}</td>
                                                </tr>
                                                <tr class="border_top">
                                                    <th></th>
                                                    <th colspan="2">Pendapatan Bersih</th>
                                                    <th style="text-align:right;padding-right:50px;">{{ 'Rp. '+ currencyFormat(pendapatan_bersih) }}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
    'https://use.fontawesome.com/releases/v5.7.2/css/all.css'
  ]
}

var tom_date = new Date();

// add a day
tom_date.setDate(tom_date.getDate() + 1);

export default {
    
    data() {
        return {
            jenis_pembayaran : '',
            labaRugiList : [],
            search: '',
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : '',
            tanggal_mulai : new Date(),
            tanggal_selesai : tom_date,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = true;
            this.$http.get("Finance/getLabaRugi?tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                if(result.data.code == '00') {
                    alert('failed get Transaksi')
                }
                else {
                    this.labaRugiList = result.data.detail;
                }
                this.$root.is_loading = false;
            }, error => {
                this.$root.is_loading = false;
                console.log('gk ok')
                context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        
        setFilter: function() {
            this.init();
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        total_saldo: function(tipe)
        {
            var total = 0;
            if(this.labaRugiList[tipe] != null)
            {
                total = this.labaRugiList[tipe][0].total_saldo_flow
            }
            return total;
        },
        printPage() {
            this.$htmlToPaper('printMe', () => {
                console.log('Printing done or got cancelled!');
            });
        }
    },
    components : {
        
    },
    computed: {
        laba_kotor: function()
        {
            return this.total_saldo('pendapatan') - this.total_saldo('harga_pokok_penjualan')
        },
        pendapatan_bersih_operasional: function()
        {
            return this.total_saldo('pendapatan') - this.total_saldo('harga_pokok_penjualan') - this.total_saldo('beban')
        },
        pendapatan_bersih: function()
        {
            return this.total_saldo('pendapatan') - this.total_saldo('harga_pokok_penjualan') - this.total_saldo('beban') + this.total_saldo('pendapatan_lainnya') - this.total_saldo('biaya_lainnya')
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/LabaRugi.vue